import { render, staticRenderFns } from "./UserGroupForm.vue?vue&type=template&id=4f6c5530&scoped=true&"
import script from "./UserGroupForm.vue?vue&type=script&lang=js&"
export * from "./UserGroupForm.vue?vue&type=script&lang=js&"
import style0 from "./UserGroupForm.vue?vue&type=style&index=0&id=4f6c5530&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6c5530",
  null
  
)

component.options.__file = "UserGroupForm.vue"
export default component.exports